export default "__VITE_ASSET__C0JymE2t__"